var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFa7RegularEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5625 7.6813L32.3187 8.43755C32.9062 9.02505 32.9062 9.97505 32.3187 10.5563L30.5 12.3813L27.6187 9.50005L29.4375 7.6813C30.025 7.0938 30.975 7.0938 31.5562 7.6813H31.5625ZM17.1125 20.0125L25.5 11.6188L28.3813 14.5L19.9875 22.8876C19.8062 23.0688 19.5812 23.2 19.3375 23.2688L15.6812 24.3125L16.725 20.6563C16.7938 20.4125 16.925 20.1875 17.1063 20.0063L17.1125 20.0125ZM27.3188 5.56255L14.9875 17.8875C14.4438 18.4313 14.05 19.1 13.8438 19.8313L12.0562 26.0813C11.9062 26.6063 12.05 27.1688 12.4375 27.5563C12.825 27.9438 13.3875 28.0875 13.9125 27.9375L20.1625 26.15C20.9 25.9375 21.5688 25.5438 22.1063 25.0063L34.4375 12.6813C36.1937 10.925 36.1937 8.07505 34.4375 6.3188L33.6813 5.56255C31.925 3.8063 29.075 3.8063 27.3188 5.56255ZM9.5 8.00005C6.4625 8.00005 4 10.4625 4 13.5V30.5C4 33.5375 6.4625 36 9.5 36H26.5C29.5375 36 32 33.5375 32 30.5V23.5C32 22.6688 31.3312 22 30.5 22C29.6688 22 29 22.6688 29 23.5V30.5C29 31.8813 27.8813 33 26.5 33H9.5C8.11875 33 7 31.8813 7 30.5V13.5C7 12.1188 8.11875 11 9.5 11H16.5C17.3313 11 18 10.3313 18 9.50005C18 8.6688 17.3313 8.00005 16.5 8.00005H9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa7RegularEdit);
export default __webpack_public_path__ + "static/media/fa7-regular_edit.05d7cf11dfa5980533056c20ccf17e89.svg";
export { ForwardRef as ReactComponent };